<template>
<div class="chapter">
<div class="inner_page">
<div id="praise">
<h1 class="left"><a href="#/007toc#praise">Praise</a></h1>
<p class="noindent">Greg has landed on a topic as ancient as time and as timely as this moment. To live in both ways is to find life itself!</p>
<blockquote>
<p class="noindent">JOHN ORTBERG, author and pastor, Menlo Park Presbyterian Church</p>
</blockquote>
<p class="noindent">Greg Boyd has a marvelous knack for sensing what is essential for the times in which we live. If faith involves coming to attention, then <i>Present Perfect</i> sounds like a needed clarion call in our profoundly distracted culture. Drawing deeply from the great guides in Scripture and history, Greg helps us to see God <i>everywhere</i> and to engage him more fully <i>anytime.</i> Get into it.</p>
<blockquote>
<p class="noindent">ALAN HIRSCH, author <i>of The Forgotten Ways</i> and coauthor of <i>Untamed,</i> (www.theforgottenways.org)</p>
</blockquote>
<p class="noindent">When people ask what has been the single most important personal discipline in my own spiritual life, I always point them toward something I learned from an old classic back in my college years: practicing God’s presence. But I’ve never had a readable contemporary book to recommend that would make this practice more widely accessible to people today, until now. Greg Boyd’s book will help a new generation of readers discover a spiritual secret that is as simple as it is profound, as transformative as it is within anyone’s reach. Highly recommended.</p>
<blockquote>
<p class="noindent">BRIAN D. MCLAREN, author/speaker/activist (brianmclaren.net)</p>
</blockquote>
<p class="noindent">A dazzling reminder that the Christian life is not just about going up when we die, but about bringing God’s kingdom down. Brother Greg offers a fiery and thoughtful invitation to see that eternity begins now and that Jesus did not simply come to prepare us to die, but to teach us to live. Read it, and hear the invitation to join God’s little infection of grace and goodness that is spreading across the globe.</p>
<blockquote>
<p class="noindent">SHANE CLAIBORNE, author, activist, and recovering sinner (www.thesimpleway.org)</p>
</blockquote>
<p class="noindent">Greg Boyd has already proven himself to be a voice of conscience in the evangelical church. Now, with <i>Present Perfect,</i> he will become a voice of sound spiritual wisdom. By (re)introducing the idea of constant awareness of God, Boyd challenges each of us to develop a Christ-consciousness. This book should be on the shelf of anyone who wants to have a deeper prayer life.</p>
<blockquote>
<p class="noindent">TONY JONES, author of <i>The Sacred Way: Spiritual Practices for Everyday Life,</i> (tonyj.net)</p>
</blockquote>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002praise.vue?191efb5c